(() => {
  if (!customElements.get('biri-mirror-models')) customElements.define('biri-mirror-models', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.querySelectorAll('[data-mirror-model]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-mirror-model]').forEach(item => item.setAttribute('aria-expanded', String(item === button)));
        this.querySelectorAll('[data-family]').forEach(panel => panel.hidden = panel.dataset.family !== button.dataset.mirrorModel);
      }));
    }
  });
  if (customElements.get('biri-mirror-family')) return;
  customElements.define('biri-mirror-family', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.choices = JSON.parse(this.querySelector('[data-mirror-data]').textContent);
      this.current = this.choices.find(item => String(item.id) === this.dataset.initial) || this.choices[0];
      if (!this.current) return;
      this.links = this.dataset.mode === 'links';
      this.render();
      if (this.links) {
        this.closest('[data-biri-product]')?.setAttribute('data-mirror-selector-ready', '');
        this.closest('.biri-product-page')?.querySelector('.biri-bulk')?.remove();
      }
    }
    candidates(field, value) {
      const selected = this.current;
      return this.choices.filter(item => item[field] === value &&
        (field === 'model' || item.model === selected.model) &&
        (field === 'model' || field === 'shape' || item.shape === selected.shape) &&
        (field === 'model' || field === 'shape' || field === 'size' || item.size === selected.size) &&
        (field === 'model' || field === 'shape' || field === 'colour' || item.colour === selected.colour));
    }
    target(field, value) {
      if (this.current[field] === value) return this.current;
      const options = this.candidates(field, value).sort((a,b) => parseFloat(a.size) - parseFloat(b.size));
      if (field === 'model') return options.find(item => parseFloat(item.size) === parseFloat(this.current.size) && item.colour === this.current.colour) || options.find(item => parseFloat(item.size) === parseFloat(this.current.size)) || options[0];
      return options.find(item => item.fulfilment === this.current.fulfilment) || options[0];
    }
    render() {
      const selected = this.current;
      this.querySelector('[data-mirror-colour]').textContent = selected.colour;
      ['shape', 'size', 'colour', 'fulfilment'].forEach(field => {
        const fieldset = this.querySelector('[data-mirror-field="' + field + '"]');
        const pool = field === 'model' ? this.choices : this.choices.filter(item => item.model === selected.model && (field === 'shape' || item.shape === selected.shape));
        let values = [...new Set(pool.map(item => item[field]))];
        if (field === 'size') values.sort((a,b) => parseFloat(a) - parseFloat(b));
        if (field === 'fulfilment') values = values.filter(value => value && this.candidates(field, value).length);
        fieldset.hidden = (field === 'model' && values.length < 2) || (field === 'shape' && values.length < 2) || (field === 'fulfilment' && values.length < 2);
        const container = fieldset.querySelector('.biri-mirror-choices');
        // Reuse controls when possible so keyboard focus survives a selection.
        const previous = new Map([...container.children].map(node => [node.dataset.value, node]));
        const nodes = values.map(value => {
          const target = this.target(field, value), active = selected[field] === value;
          const control = previous.get(value) || document.createElement(this.links ? 'a' : 'button');
          control.className = 'biri-mirror-choice' + (field === 'colour' ? ' is-swatch' : '');
          control.dataset.value = value;
          if (this.links) {
            if (target) control.href = target.url; else control.removeAttribute('href');
            if (active) control.setAttribute('aria-current','page'); else control.removeAttribute('aria-current');
            control.setAttribute('aria-disabled', String(!target));
          } else {
            control.type = 'button'; control.disabled = !target;
            control.setAttribute('aria-pressed', String(active));
            control.onclick = () => { if (target) { this.current = target; this.render(); } };
          }
          control.title = value + (!target ? ' — ' + this.dataset.unavailable : '');
          if (field === 'colour') {
            control.setAttribute('aria-label',value);
            if (!control.firstChild) control.append(document.createElement('span'));
            control.firstChild.style.background = value === 'Black' ? '#25282c' : '#ff761b';
          } else control.textContent = value;
          return control;
        });
        [...container.children].filter(node => !nodes.includes(node)).forEach(node => node.remove());
        nodes.forEach((node,index) => { if(container.children[index] !== node) container.insertBefore(node,container.children[index] || null); });
      });
      if (this.links) return;
      this.querySelector('[data-mirror-price]').textContent = selected.price;this.querySelector('[data-biri-shipping-badge]').hidden=!selected.shippingIncluded;
      this.querySelector('[data-mirror-sku]').textContent = selected.sku;
      this.querySelector('[data-mirror-stock]').textContent = selected.available ? this.dataset.available : this.dataset.sold;
      const form = this.querySelector('form');
      form.querySelector('[name=id]').value = selected.id;
      const productId = form.querySelector('[name="product-id"]'); if (productId) productId.value = selected.productId;
      const add = form.querySelector('[type=submit]'); add.disabled = !selected.available;
      add.textContent = selected.available ? this.dataset.add : this.dataset.sold;
      this.querySelector('[data-mirror-details]').href = selected.url;
      if (this.imageId === selected.id) return; this.imageId = selected.id;
      const image = this.querySelector('.biri-mirror-photo img'), thumbs = this.querySelector('[data-mirror-thumbnails]');
      const show = index => {
        if (image) { image.removeAttribute('srcset'); image.src = selected.images[index]; image.alt = this.dataset.title + ' — ' + selected.colour + ' — ' + selected.size; }
        [...thumbs.children].forEach((node,i) => node.setAttribute('aria-pressed',String(i === index)));
      };
      thumbs.replaceChildren();
      selected.images.forEach((src,index) => {
        const button = document.createElement('button'); button.type = 'button';
        button.setAttribute('aria-label',this.dataset.title + ' — image ' + (index + 1));
        const thumb = document.createElement('img'); thumb.src = src; thumb.alt = ''; thumb.loading = 'lazy';
        button.append(thumb); button.addEventListener('click',() => show(index)); thumbs.append(button);
      });
      if (selected.images.length) show(0);
    }
  });
})();
